module.exports = __webpack_public_path__ + "static/media/supplier.6d2a5e13.jpg";